export default {"src":"/_next/static/media/shoppay.ee735cbe.svg","height":25,"width":104,"blurWidth":0,"blurHeight":0};